/* eslint-disable react-hooks/exhaustive-deps */
import { IMetrics } from '../entities/cdn';
import { useEffect, useState } from "react"
import { fetchMetrics } from "services/cdn"

export const usePrice = (toProduct: string, fromProduct: string, toProductType: string) => {
    const [price, setPrice] = useState(0)

    useEffect(() => {
        fetchMetrics({
            fromProduct,
            toProduct,
            toProductType,
        }).then((response: any) => {
            const metrics = response.data as IMetrics;
            setPrice(metrics.Value)
        }).catch((error: any) => {
            console.log('error', error)
        })
    }, [])

    useEffect(() => {
        // console.log('usePrice:', { fromProduct, toProduct }, price)
    }, [price, toProduct])

    return price;
}